<!-- @format -->

<ng-container *transloco="let t">
  @if (data$ | async; as data) {
    <div class="container sis-pt-md">
      <sis-breadcrumbs></sis-breadcrumbs>
      <sis-page-title [title]="t('APPLICATION_STRUCTURE_OF_STUDIES')" [showCrumbs]="true" />
      <app-plan-version-toggle (toggleChanged)="this.planVersionToggleChanged($event)" />
      <div class="row">
        <div class="col-12">
          <app-plan-header
            [allStudentPlans]="data.allStudentPlans"
            [currentPlan]="data.plan"
            [menuOptions]="menuOptions$ | async"
            (selectPlan)="this.handlePlanChange($event)">
          </app-plan-header>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-plan-notification [planStructureData]="data"> </app-plan-notification>
        </div>
      </div>
      <div class="sis-mb-sm">
        @if (data.hasOptionsRequiringConfirmation) {
          <fudis-notification [variant]="'warning'">
            <fudis-body-text>
              {{ t("PLAN.STATE.HAS_OPTIONS_REQUIRING_CONFIRMATION") }}
            </fudis-body-text>
          </fudis-notification>
        }
      </div>
      <div class="sis-mb-sm">
        @if (data.outDatedCourseUnitsInPlan?.length > 0) {
          <fudis-notification [variant]="'warning'">
            <fudis-body-text>
              {{ t("PLAN.STATE.OUTDATED_COURSE_UNITS_IN_THE_PLAN") }}
              <fudis-button
                [label]="t('PLAN.STATE.OPEN_OUTDATED_COURSE_UNITS_DIALOG')"
                (handleClick)="openOutdatedCourseUnitsModal(data, data.outDatedCourseUnitsInPlan)"></fudis-button>
            </fudis-body-text>
          </fudis-notification>
        }
      </div>
      <div class="sis-mb-sm">
        @if (data.studyRightStatus.hasNoStudyRight) {
          <fudis-notification [variant]="'warning'" data-cy="plan-no-study-right-notification">
            <fudis-body-text>
              {{ t("PLAN_STUDY_RIGHT_STATE.NO_STUDY_RIGHT_FOR_PLAN") }}
            </fudis-body-text>
          </fudis-notification>
        }
      </div>
      <div class="sis-mb-sm">
        @if (data.studyRightStatus.hasStudyRightButNoneActive) {
          <fudis-notification [variant]="'warning'" data-cy="plan-no-active-study-right-notification">
            <fudis-body-text>
              {{ t("PLAN_STUDY_RIGHT_STATE.STUDY_RIGHT_FOR_PLAN_BUT_NONE_ACTIVE") }}
            </fudis-body-text>
          </fudis-notification>
        }
      </div>
      <div class="sis-mb-sm">
        @if (termRegistrationRequired$ | async) {
          @if (missingTermRegistration$ | async) {
            <fudis-notification [variant]="'warning'" data-cy="plan-missing-term-registration-notification">
              <fudis-body-text>
                {{ t("PLAN_STUDY_RIGHT_STATE.TERM_REGISTRATION_MISSING") }}
              </fudis-body-text>
            </fudis-notification>
          }
        }
      </div>
      @let unplannedCount = unplannedAttainmentsCount(data);
      @if (unplannedCount > 0) {
        <div class="sis-mb-sm">
          <fudis-notification [variant]="'info'">
            <fudis-body-text>
              {{ t("PLAN.STATE.UNPLANNED_ATTAINMENTS_IN_PLAN", { count: unplannedCount }) }}
              <a
                fudisLink
                [href]="'#'"
                [title]="t('PLAN.STATE.PLACE_ATTAINMENTS_TO_PLAN')"
                [external]="false"
                [size]="'md'"
                (click)="openUnallocatedAttainmentsDialog(data)"></a>
            </fudis-body-text>
          </fudis-notification>
        </div>
      }
      @for (moduleId of data.planStateAndData.planStateObject.education.selectedModuleIds; track moduleId) {
        @if (data.planStateAndData.planData.modulesById[moduleId]?.type === "DegreeProgramme") {
          <div class="sis-mb-sm">
            <sis-graduation-workflow-notification
              [module]="data.planStateAndData.planData.modulesById[moduleId]"
              [planValidationResult]="data.planValidationResult">
            </sis-graduation-workflow-notification>
          </div>
        }
      }
      @if (data.studyRightStatus.tutoringStudyRight) {
        <div class="row">
          <div class="d-flex justify-content-end">
            <fudis-button
              [label]="t('SIS_COMPONENTS.PLAN.SHOW_MESSAGES.STUDENT')"
              [ariaLabel]="t('SIS_COMPONENTS.PLAN.SHOW_MESSAGES.STUDENT')"
              [size]="'small'"
              [variant]="'primary'"
              (handleClick)="this.openTutoring()">
            </fudis-button>
          </div>
        </div>
      }
      <div class="row">
        <div class="col-12">
          <sis-plan-structure-education
            [sisPlanStructureContext]="{
              planStateObject: data.planStateAndData.planStateObject,
              planData: data.planStateAndData.planData,
            }"
            [education]="data.validatablePlanEducation">
          </sis-plan-structure-education>
        </div>
      </div>
    </div>
  }
</ng-container>
